import React from 'react';
import PropTypes from 'prop-types';
import { TextField, SimpleShowLayout, FunctionField } from 'react-admin';
import Header from '../../../shared/header';
import { getCountryName } from '../../../shared/country';

export const BillingAddress = ({ resource, record, classes, isItaly }) => (
  <SimpleShowLayout resource={resource} record={record}>
    <Header label="common.null" />
    <TextField
      source="billingAddress.streetName"
      className={classes.field}
      classes={{ root: classes.fieldContent }}
      id="Selenium-businessDetails-Billing-Address-streetName"
    />
    <TextField
      source="billingAddress.postalCode"
      className={classes.field}
      classes={{ root: classes.fieldContent }}
      id="Selenium-businessDetails-Billing-Address-postalCode"
    />
    <TextField
      source="billingAddress.city"
      className={classes.field}
      classes={{ root: classes.fieldContent }}
      id="Selenium-businessDetails-Billing-Address-City"
    />
    <FunctionField
      label="resources.business.fields.billingAddress.country"
      className={classes.field}
      classes={{ root: classes.fieldContent }}
      id="Selenium-businessDetails-Billing-Address-Country"
      render={r => getCountryName(r.billingAddress && r.billingAddress.countryCode)}
    />
    {isItaly && (
      <TextField
        source="billingAddress.region"
        label="resources.business.fields.invoicingRegion"
        className={classes.field}
        classes={{ root: classes.fieldContent }}
        id="businessInvoicingAddress"
      />
    )}
  </SimpleShowLayout>
);

BillingAddress.propTypes = {
  record: PropTypes.shape({}),
  classes: PropTypes.shape({
    field: PropTypes.string,
    fieldContent: PropTypes.string,
  }),
  resource: PropTypes.string,
  isItaly: PropTypes.bool,
};
